import { useSelector } from "react-redux";

export const useToken = () => useSelector((state) => state.areaPage.token);
export const useTokenExpiresAt = () => useSelector((state) => state.areaPage.tokenExpiresAt);
export const useSitesLoading = () => useSelector((state) => state.areaPage.sitesLoading);
export const useSites = () => useSelector((state) => state.areaPage.sites);
export const useSiteUuid = () => useSelector((state) => state.areaPage.siteUuid);
export const useOrganizationUuid = () => useSelector((state) => state.areaPage.organizationUuid);
export const useMlsIds = () => useSelector((state) => state.areaPage.mlsIds);

export const useAreaPageTemplateUuid = () => useSelector((state) => state.areaPage.areaPageTemplateUuid);
export const usePage = () => useSelector((state) => state.areaPage.page);
export const useAddPageLoading = () => useSelector((state) => state.areaPage.addPageLoading);
export const useAddPageError = () => useSelector((state) => state.areaPage.addPageError);
export const usePageUuid = () => useSelector((state) => state.areaPage.pageUuid);
export const usePages = () => useSelector((state) => state.areaPage.pages);
export const useContentComponents = () => useSelector((state) => state.areaPage.pageContentComponents);
export const useComponents = () => useSelector((state) => state.areaPage.components);
export const usePageSettings = () => useSelector((state) => state.areaPage.pageSettings);
export const useArea = () =>
  useSelector(
    (state) =>
      state.areaPage.pageSettings?.variables?.vars?.find((variable) => variable.key === "location")?.value,
  );
export const useAreaSelection = () => useSelector((state) => state.areaPage.area);
export const useFeaturedImageComponent = () =>
  useSelector((state) =>
    state.areaPage.pageContentComponents?.find((component) => component.name === "Hero"),
  );
export const useAreaOverviewComponent = () =>
  useSelector((state) =>
    state.areaPage.pageContentComponents?.find((component) => component.name === "Content CTA"),
  );
export const useMarketStatsComponent = () =>
  useSelector((state) =>
    state.areaPage.pageContentComponents?.find((component) => component.name === "Market Stats"),
  );
export const useLinksComponent = () =>
  useSelector((state) =>
    state.areaPage.pageContentComponents?.find((component) => component.name === "Links"),
  );
export const useFeaturedListingsComponent = () =>
  useSelector((state) =>
    state.areaPage.pageContentComponents?.find((component) => component.name === "Featured Properties"),
  );
export const useContactCTAComponent = () =>
  useSelector((state) =>
    state.areaPage.pageContentComponents?.find((component) => component.name === "Contact CTA Hero"),
  );
export const useNeighborhoodComponent = () =>
  useSelector((state) =>
    state.areaPage.pageContentComponents?.find((component) => component.name === "Neighborhood"),
  );

export const useIsNewPage = () => useSelector((state) => state.areaPage.isNewPage);
